module.exports = __webpack_public_path__ + "img/telegram-parser-48.71ab07f1.jpg";